/* istanbul ignore file */

import { AxiosPromise } from 'axios';
import { IFee } from '../utils/constants';
import { axiosInstance } from './axiosInstance';

export const computeFees = ({ submissionId }: { submissionId: string }): AxiosPromise =>
  axiosInstance.get<{ fees: IFee[] }>(`/fees/compute/${submissionId}`);
